import { Component, inject, Input } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { Observable } from 'rxjs';
import { ProcessingOrders } from 'src/app/models/supplier-portal/supplier/supplierOrdersProcessing.models';
import { OrderHelperService } from 'src/app/services/portal-supplier/order-helper.service';

@Component({
  selector: 'app-see-batch',
  standalone: false,
  templateUrl: './see-batch.component.html',
  styleUrl: './see-batch.component.scss',
})
export class SeeBatchComponent {
  @Input() public productToWorkOn: ProcessingOrders.IProductInOrder | null =
    null;
  private orderService = inject(OrderHelperService);
  public popoverCtrl = inject(PopoverController);

  ngOnInit() {}

  public get getBDocuments(): Observable<
    ProcessingOrders.IProductBatchDocument[]
  > {
    return this.orderService.selectedDocuments.asObservable();
  }

  public get getBatch(): Observable<ProcessingOrders.IProductBatch> {
    return this.orderService.selectedBatch.asObservable();
  }

  public get getProduct(): Observable<ProcessingOrders.IProductInOrder> {
    return this.orderService.selectedProduct.asObservable();
  }
  changePassword() {
    this.popoverCtrl.dismiss('password');
  }

  logout() {
    this.popoverCtrl.dismiss('logout');
  }
}
